
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expire"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllfactWhereWhereConditions"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllfactOrderByOrderByClause"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allfact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"TypeScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"expire"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expire"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nofact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fact_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fact_ref"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code_tier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tier_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tier_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_limite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_ht"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_tva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_ttc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_exe_tva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_timbre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_avc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_grt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_net"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mont_remise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_paye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_reste"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doc_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expire"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"delai_paye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modepaiement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_regl"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":639}};
    doc.loc.source = {"body":"query (\r\n  $TypeScope: Int\r\n  $expire: Int\r\n  $where: QueryAllfactWhereWhereConditions\r\n  $orderby: [QueryAllfactOrderByOrderByClause!]\r\n) {\r\n  allfact(\r\n    TypeScope: $TypeScope\r\n    expire: $expire\r\n    where: $where\r\n    orderBy: $orderby\r\n  ) {\r\n    id\r\n    nofact\r\n    fact_date\r\n    fact_ref\r\n    code_tier\r\n    tier_name\r\n    tier_id\r\n    date_limite\r\n    mont_ht\r\n    mont_tva\r\n    mont_ttc\r\n    mont_exe_tva\r\n    mont_timbre\r\n    mont_avc\r\n    mont_grt\r\n    mont_net\r\n    mont_remise\r\n    ttc_paye\r\n    ttc_reste\r\n    status_name\r\n    doc_type\r\n    expire\r\n    statut_id\r\n    delai_paye\r\n    modepaiement\r\n    date_regl\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
